export type EventPayload = any;

class EventEmitter {
  private callbackRegistry = new Map<string, Function[]>();
  private onceCallbackRegistry = new Map<string, Function[]>();

  on(name: string, callback: Function) {
    const callbackList = this.callbackRegistry.get(name) || [];
    if (callbackList.includes(callback)) {
      return;
    }
    this.callbackRegistry.set(name, [...callbackList, callback]);
  }

  once(name: string, callback: Function) {
    const callbackList = this.onceCallbackRegistry.get(name) || [];
    if (callbackList.includes(callback)) {
      return;
    }
    this.onceCallbackRegistry.set(name, [...callbackList, callback]);
  }

  off(name: string, callback: Function) {
    let callbackList = this.callbackRegistry.get(name) || [];
    callbackList = callbackList.filter(listItem => listItem !== callback);
    this.callbackRegistry.set(name, callbackList);
  }

  emit(name: string, payload?: EventPayload) {
    const callbackList = this.callbackRegistry.get(name) || [];
    const onceCallbackList = this.onceCallbackRegistry.get(name) || [];
    [...callbackList, ...onceCallbackList].forEach(cb => {
      cb(payload);
    });
    if (onceCallbackList.length) {
      this.onceCallbackRegistry.delete(name);
    }
  }
}

export default EventEmitter;
